import * as CartService from '../services/CartService'

export const UPDATE_PARTICIPANT_FOR_ITEM_REQUEST = 'UPDATE_PARTICIPANT_FOR_ITEM_REQUEST';
export const UPDATE_PARTICIPANT_FOR_ITEM_SUCCESS = 'UPDATE_PARTICIPANT_FOR_ITEM_SUCCESS';
export const UPDATE_PARTICIPANT_FOR_ITEM_FAILURE = 'UPDATE_PARTICIPANT_FOR_ITEM_FAILURE';

export function updateParticipantForItemRequest() {
    return {
        type: UPDATE_PARTICIPANT_FOR_ITEM_REQUEST
    }
}

export function updateParticipantForItemSuccess(payload) {
    return {
        type: UPDATE_PARTICIPANT_FOR_ITEM_SUCCESS,
        payload
    }
}

export function updateParticipantForItemFailure(payload) {
    return {
        type: UPDATE_PARTICIPANT_FOR_ITEM_FAILURE,
        payload
    }
}

export function updateParticipantForItem(participant, itemIdentifier, identifier) {
    return (dispatch) => {
        dispatch(updateParticipantForItemRequest());

        CartService.updateParticipantForItem(participant, itemIdentifier, identifier)
            .then(response => {
                dispatch(updateParticipantForItemSuccess(response));
            })
            .catch(error => {
                dispatch(updateParticipantForItemFailure(error));
            });
    }
}
